import { useUserStore } from '@/stores/userStore';

export function useUserRole() {
  const role = useUserStore((s) => s.role);
  const roleResolved = useUserStore((s) => s.roleResolved);
  return {
    role,
    roleResolved,
    isPrimary: role === 'PRIMARY',
    isCoAdmin: role === 'CO_ADMIN',
    isEditor: role === 'EDITOR',
    isCaregiver: role === 'VIEWER',
  };
}
